import { useEffect, useRef } from "react";
function useEffectAfterMount(cb, dependencies) {
    const justMounted = useRef(true);
    useEffect(()=>{
        if (!justMounted.current) return cb();
        justMounted.current = false;
    }, dependencies);
}
const src_useEffectAfterMount = useEffectAfterMount;
export default src_useEffectAfterMount;
